import { render, staticRenderFns } from "./product-pictures.vue?vue&type=template&id=8fd5fa9a&scoped=true"
import script from "./product-pictures.vue?vue&type=script&lang=ts"
export * from "./product-pictures.vue?vue&type=script&lang=ts"
import style0 from "./product-pictures.vue?vue&type=style&index=0&id=8fd5fa9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd5fa9a",
  null
  
)

export default component.exports